// import { routerErrror } from '../route-navigation'

function viewSheet() {
  if (this.isAuthenticated) {
    this.flagViewCode = false
    this.flagViewGCode = false
  }
}

function viewCodeDialog(item) {
  if (!this.isAuthenticated) {
    this.status.login_required = true
  } else {
    this.status.login_required = false
    this.$store.commit('GIFTCODE_DETAIL', item)
    this.$store.dispatch('GIFTCODE_SHOW', {
      event_id: item.id,
    })
    if (item.type === 'normal') {
      this.received = true
      this.received_code = item.code
    } else {
      if (item.has_delivered === true) {
        this.received_code = this.giftcode_show.code
      } else {
        this.received_code = ''
      }
    }

    if (item.type === 'facebook' && this.$route.query.puid) {
      this.received = true
      this.received_code = item.code
      this.$store.commit('updateCode', item.code)
    }

    if (item.code && item.type === 'facebook') {
      this.received = true
      this.received_code = item.code
    }

    if (item.has_delivered === true) {
      this.$store.commit('updateCode', item.code)
    }
  }
}

export { viewSheet, viewCodeDialog }
